<template>
  <div class="success">
      <div class="icon"></div>
      <div class="txt">身份审核中</div>
      <div class="stxt">请耐心等待~</div>
  </div>
</template>

<script>

export default {
  data() {
    //
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
 
  }
};
</script>

<style lang="scss">
.success{
    padding-top:2rem;
    .icon{
        width:3.2rem;
        height:3.2rem;
        background:url("../../assets/images/shenhe.png") no-repeat center center;
        background-size:100% 100%;
        margin:.5rem auto;
    }
    .txt{
        width:100%;
        text-align:center;
        line-height:.8rem;
        color:#708AB2;
        font-size:.48rem;
    }
    .stxt{
        width:100%;
        text-align:center;
        line-height:.6rem;
        color:#000;
        font-size:.32rem;

    }
}
</style>



// WEBPACK FOOTER //
// src/components/success/index.vue